module.exports = __webpack_public_path__ + "img/bg-login.d3af7f04.svg";